export const CAR_PROPERTIES = {
  ONLINE_SELF_EVALUATION: 6410,
  CAR_PURCHASE_TRACK: 7100,
  SELF_EVALUATION_ASSUMPTION: 6414
};